var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.showDataExclusionWindow,
            width: "800px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDataExclusionWindow = $event
            },
            close: _vm.closeDataExclusion,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataExclusionRef",
              attrs: {
                "label-position": "top",
                size: "small",
                model: _vm.formData,
              },
            },
            [
              _vm.stepType === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.SelectTheVTagType"),
                            prop: "vTagType",
                            rules: {
                              required: true,
                              message: _vm.$t("placeOrder.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.vTagTypeChange },
                              model: {
                                value: _vm.formData.vTagType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "vTagType", $$v)
                                },
                                expression: "formData.vTagType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "COLLECT" } }, [
                                _vm._v(_vm._s(_vm.$t("mdfeTranslate.Coleta"))),
                              ]),
                              _c("el-radio", { attrs: { label: "DELIVERY" } }, [
                                _vm._v(_vm._s(_vm.$t("mdfeTranslate.Entrega"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.PleaseEnterVTagKey"),
                            prop: "vTagNum",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseInput"),
                              },
                              model: {
                                value: _vm.formData.vTagNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "vTagNum",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.vTagNum",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                  staticStyle: { "font-size": "26px" },
                                  on: { click: _vm.appendTag },
                                }),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.SelectedVTagQueue"),
                            prop: "vTagNumList",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                height: "200px",
                                "overflow-y": "auto",
                                border: "1px solid #c0c4cc",
                                "border-radius": "5px",
                              },
                            },
                            _vm._l(
                              _vm.formData.vTagNumList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      border: "1px solid #c0c4cc",
                                      "border-radius": "3px",
                                      margin: "5px",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(item) + " "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          padding: "5px 0",
                                        },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeVTagNum(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                          staticStyle: {
                                            "font-size": "20px",
                                            color: "#f00",
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType === 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.PleaseEnterMdfeKey"),
                            prop: "mdfeKey",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseInput"),
                              },
                              model: {
                                value: _vm.formData.mdfeKey,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "mdfeKey",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.mdfeKey",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                  staticStyle: { "font-size": "26px" },
                                  on: { click: _vm.appendMdfe },
                                }),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.SelectedMdfeQueue"),
                            prop: "mdfeKeyList",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                height: "200px",
                                "overflow-y": "auto",
                                border: "1px solid #c0c4cc",
                                "border-radius": "5px",
                              },
                            },
                            _vm._l(
                              _vm.formData.mdfeKeyList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      border: "1px solid #c0c4cc",
                                      "border-radius": "3px",
                                      margin: "5px",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(item) + " "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          padding: "5px 0",
                                        },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeMdfe(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                          staticStyle: {
                                            "font-size": "20px",
                                            color: "#f00",
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType === 3
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table-height",
                          attrs: {
                            data: _vm.tableData,
                            border: "",
                            "header-cell-style": {
                              background: "#f2f2f2",
                              color: "black",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("collectionCenter.carNumber"),
                              prop: "tags",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "mdfeTranslate.CarrierNumberAssociatedWithNumberPackages"
                              ),
                              prop: "packagesCount",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("mdfeTranslate.RepeatPackages"),
                              prop: "repeatCount",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("mdfeTranslate.RepeatRate"),
                              prop: "repeatRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.stepType !== 3
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onNext()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.next")))]
                  )
                : _vm._e(),
              _vm.stepType === 3
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.confirmDelete },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }